export default {
  helloText: 'Добрый день!',
  helloTextWithName: 'Добрый день, {firstName}!',
  goBack: 'Назад',
  progress: {
    photos: 'Фотографии',
    videos: 'Видео',
    of: 'из',
  },
  constructionStages: 'Этапы строительства',
  text: {
    profileIsEmpty: 'Заполните профиль, чтобы мы смогли предоставить вам консультацию по квартире',
    docsIsNotUploaded: 'Для всех операций по квартире нужны документы. Советуем отправить их заранее',
    docsIsUploaded: 'Ваши документы находятся на проверке. Вы можете перезагрузить их в любой момент',
  },
  buttonText: {
    profileIsEmpty: 'Заполнить профиль',
    docsIsNotUploaded: 'Отправить документы',
    docsIsUploaded: 'Отправить документы повторно',
  },
  banner: {
    title: 'Подберем \nквартиру ',
    titleSpan: 'вместе',
    button: 'Получить консультацию',
  },
  recommendationDealTexts: {
    type_of_ownership: 'После выбора типа собственности \nзаполните данные',
    load_owners: 'Заполните всю информацию \nпо выбранному типу собственности',
    pay_options: 'Заполните всю информацию \nпо способу оплаты',
    load_pay_data: 'Заполните всю информацию \nпо способу оплаты',
    send_deal_data: 'После успешной проверки документов \nвам станет доступен договор',
    agreement: 'Прислали вам договор. Согласуйте и \nвыберите способ подписания или оставьте комментарий.',
    signing_options: 'Выберите удобный для вас способ \nи время подписания договора',
    check_contract_signed:
      'После подписания договора необходимо \nоплатить госпошлину для регистрации договора в Росреестре',
    pay_state_duty: 'Оплатите госпошлину через Госуслуги \nили в банке. Затем подтвердите оплату',
    transaction: 'После регистрации вам станет доступна \nоплата по договору',
    pay_under_contract: 'Произведите оплату по реквизитам \nиз договора, затем подтвердите её',
  },
  completeDealButtonTextsProfile: {
    type_of_ownership: 'Выбрать',
    load_owners: 'Заполнить',
    pay_options: 'Заполнить',
    load_pay_data: 'Заполнить',

    agreement: 'Посмотреть',
    signing_options: 'Выбрать',

    pay_state_duty: 'Подтвердить оплату',
  },
  completeDealButtonTexts: {
    type_of_ownership: 'Заполнить данные',
    load_owners: 'Заполнить данные',
    pay_options: 'Заполнить данные по оплате',
    load_pay_data: 'Заполнить данные по оплате',

    agreement: 'Посмотреть договор',
    signing_options: 'Выбрать способ подписания',

    pay_state_duty: 'Подтвердить оплату',
  },
  approveModal: {
    title: 'Согласование договора',
    title2: 'Ознакомьтесь с проектом договора и согласуйте его',
    goOn: 'Продолжить',
    cancel: 'Отменa',
    back: 'Назад',
    send: 'Отправить ответ',
    approveContract: 'Согласовать договор?',
    yes: 'Да',
    no: 'Нет',
    comment: 'Комментарий',
    submitted: 'Ваш ответ отправлен',
    contractProject: 'Проект договора',
    required: 'Обязательное поле',
    requiredMin: 'Минимальное количество символов - 10',
    requiredMax: 'Максимальное количество символов - 500',
    description:
      'Вам необходимо согласовать проект договора в части корректности Ваших данных, также проверьте параметры выбранного объекта (раздел 2 и Приложение 1), его стоимость и форму расчетов (раздел 3).',
    description2:
      'Обращаем Ваше внимание, что на согласование проекта договора отводится 24 часа. При отсутствии обратной связи документ считается согласованным',
  },
  flatsList: {
    flats: 'Квартиры',
    interesting: 'Вы интересовались',
    objects: 'Мои объекты',
    myDeals: 'Мои сделки',
    favourite: 'Избранное',
    booking: 'Забронированные',
    noNotifications: 'Кажется, здесь ещё нет уведомлений',
    noDeals: 'Здесь будут отображаться ваши сделки',
    noDealsPreposal:
      'Вы можете забронировать любую квартиру для последующей покупки. Просто выберите подходящую из нашего каталога.',
    noDealsLink: 'Смотреть квартиры',
    dealsTable: {
      leadId: '№ сделки',
      objectType: 'Тип объекта',
      objectZhk: 'Жилой комплекс',
      objectBuildingNumber: 'Дом',
      objectNumber: '№ объекта',
      status: 'Статус',
      contractSum: 'Сумма сделки',
      manager: 'Менеджер',
      rowsPerPage: 'Строк в таблице',
      reminder: 'Памятка клиенту',
      approve: 'Согласовать договор',
      mortgage: 'Заявка на ипотеку',
      checkList: 'Чек-лист',
      submitDocuments: 'Подать документы',
      submitDocumentsModal: {
        title: 'Подать документы',
        dropzone: 'Перетащите файлы сюда или выберите на компьютере',
        selectButton: 'Выбрать файлы',
        hint: 'Доступные форматы: jpg, pdf, xls, xlsx, doc, docx. Максимальный размер файла — 30 МБ.',
        formatError: 'Загрузите документ в формате jpg, pdf, xls, xlsx, doc или docx.',
        sizeError: 'Размер файла не должен превышать 30 МБ.',
        emptyError: 'Выберите хотя бы один документ.',
        submitError: 'Не удалось отправить документы. Попробуйте позже.',
        submit: 'Отправить',
        successTitle: 'Документы отправлены',
        successText:
          'Ваши документы успешно отправлены на проверку. Ожидайте уведомления об изменении статуса сделки. Менеджер сделки свяжется с вами при необходимости уточнения. Также вы можете самостоятельно отслеживать информацию и статус сделки в личном кабинете в разделе «Мои сделки».',
        ok: 'Ок'
      }
    },
    instructions: 'Документы и инструкции',
    flatDescription: '{roomsAmount}-к квартира {areaTotal}м²',
    emptyInfo: 'Не указано',
    floor: 'Этаж: {floor}',
    housing: '№ кв.: {number}',
    flatPrice: '{price} ₽',
    notFavouriteEmoji: '👀',
    notFavouriteTitle: 'Нет избранных квартир',
    notFavouriteDescription:
      'Откладывайте в избранное понравившиеся квартиры, чтобы вернуться к ним позже. Просто выберите любую из каталога',
    notBookingEmoji: '🤔',
    notMyTitle: 'Нет объектов',
    notMyDescription:
      'У Вас пока нет купленных объектов. Вы можете забронировать любую квартиру для последующей покупки. Просто выберите подходящую из каталога',
    notBookingTitle: 'Нет забронированных',
    notBookingDescription:
      'Вы можете забронировать любую квартиру для последующей покупки. Просто выберите подходящую из каталога',
    viewFlats: 'Смотреть квартиры',
    bookingFlat: 'Забронировать',
    cancelRequest: 'Отменить заявку {time}',
    requestSent: 'Заявка отправлена',
    requestSentWithEmoji: 'Заявка отправлена 👍',
    bookingExpired: 'Истекло',
    bookingWait: 'Ожидает',
    bookingDenied: 'Отказано',
    bookingDone: 'Завершено',
    bookingOnline: 'Онлайн сделка',
    cancel: 'Отмена',
    firstCompleteProfile: 'Сначала заполните профиль',
    complete: 'Заполнить',
    goBuy: 'Начать покупку',
    noDealDocsNotUploaded: 'Сначала отправьте документы 🤔',
    noDealNotVerified: 'Дождитесь проверки документов 🤔',
    dealAlreadyExist: 'У вас уже имеется активная сделка 🤔',
    send: 'Отправить',
  },
  myFlats: {
    titleSingle: 'Моя квартира',
    titleMultiple: 'Мои квартиры',
    flatDescription: '{roomsAmount}-к квартира {areaTotal}м²',
    complexInfo: 'ЖК {complexTitle} • корп. {section}',
    params: {
      area: {
        title: 'Жилая пл.',
        value: '{areaLiving} м²',
      },
      floor: {
        title: 'Этаж',
        value: '{floor}/{maxFloor}',
      },
      kitchen: {
        title: 'Кухня',
        value: '{areaKitchen} м²',
      },
      dateComplete: {
        title: 'Срок сдачи',
      },
    },
    complexNum: '№ {number}',
    stageOfConstruction: 'Этапы строительства',
    flatDocuments: 'Документы по объекту',
    report: 'Сообщить об ошибке',
    registerOwnership: 'Регистрация права собственности',
    keyGetting: 'Передача объекта',
    regOwnershipConfirmModal: {
      beforePPDLink:
        'Нажимая на кнопку "Регистрация права собственности", Вы даете согласие<br/>на обработку своих персональных данных<br/>и соглашаетесь с ',
      PPDLink: 'условиями их обработки',
      beforeOfferLink: ',</br/>а также соглашаетесь с ',
      offerLink: 'офертой',
      cancel: 'Отмена',
      accept: 'Принимаю',
    },
    objectDocsModal: {
      title: 'Документы по объекту',
      name: 'Название документа',
      date: 'Дата загрузки',
    },
  },
  actions: {
    title: 'Акции и предложения',
    dates: {
      0: 'до {day} января {year}',
      1: 'до {day} февраля {year}',
      2: 'до {day} марта {year}',
      3: 'до {day} апреля {year}',
      4: 'до {day} мая {year}',
      5: 'до {day} июня {year}',
      6: 'до {day} июля {year}',
      7: 'до {day} августа {year}',
      8: 'до {day} сентября {year}',
      9: 'до {day} октября {year}',
      10: 'до {day} ноября {year}',
      11: 'до {day} декабря {year}',
    },
  },
  additionalServices: {
    topLabel: 'От партнёров',
    title: 'Подарки от Hoff \nдля новосёлов АБД',
    buttonText: 'Узнать подробнее',
  },
  newlyBoughtFlat: {
    title: 'Поздравляем \nс покупкой',
    titleFlatWord: ' квартиры!',
    flatDescription: '{complexTitle} • {roomsAmount}-к квартира {areaTotal}м²',
    flatDescriptionStudio: '{complexTitle} • квартира {areaTotal}м²',
    continue: 'Ура, спасибо!',
  },
  notifications: {
    types: {
      deal: 'Сделка',
      contract: 'Договор',
      promo: 'Акция'
    }
  },
  mainAction: {
    button: 'Подробнее'
  }
};
